import { render } from "./CustomTemplate.vue?vue&type=template&id=78d3a01f"
import script from "./CustomTemplate.vue?vue&type=script&lang=js"
export * from "./CustomTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script